import React from 'react';
// 1. Import styles from CSS Modules
import homeStyles from './Home.module.css';
import contactStyles from './Contact.module.css';

// Component & Asset Imports
import MyMap from '../Components/MyMap';
import marker from "../Assets/marker.png";
import call from "../Assets/call.png";
import mail from "../Assets/mail.png";

export const Contact = () => {
    const lat = 22.732746;
    const lng = 75.810289;

    const contactInfo = [
        {
            icon: marker,
            alt: "Address",
            text: `Cirkitex Semiconductor Private Limited, 
                   131 RN CITY, Garima Vidhya Vihar, 
                   Airport Road, Indore, Madhya Pradesh, 
                   452005, India`
        },
        {
            icon: call,
            alt: "Phone",
            text: "Mobile: +91 8764889915"
        },
        {
            icon: mail,
            alt: "Email",
            text: "Email: contact@cirkitex.com"
        }
    ];

    return (
        // 2. Apply the main container and content wrapper for the themed background
        <div className={homeStyles.mainContainer}>
            <div className={homeStyles.contentWrapper}>
                {/* Page Title */}
                <h3 className={contactStyles.heading}>
                    Contact Us
                </h3>

                {/* Map */}
                <div name="Map" className={contactStyles.mapContainer}>
                    <MyMap lat={lat} lng={lng} />
                </div>

                {/* Contact Info Section */}
                <div className={contactStyles.contactSection}>
                    {contactInfo.map((info, idx) => (
                        <div
                            key={idx}
                            // 3. Conditionally apply the addressCard class for the first item
                            className={
                                idx === 0
                                    ? `${contactStyles.contactCard} ${contactStyles.addressCard}`
                                    : contactStyles.contactCard
                            }
                        >
                            <img src={info.icon} alt={info.alt} className={contactStyles.contactIcon} />
                            <p className={contactStyles.contactText}>
                                {info.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
